import { z } from 'zod';

import objectPassthrough from '../objectPassthrough';

interface OrganizationClientSettings {
  hidePersonalLoginsOnMobile?: boolean;
}

// NOTE: we keep passthrough here so old clients do not drop newer settings
const OrganizationClientSettings = objectPassthrough({
  hidePersonalLoginsOnMobile: z.boolean().optional(),
});

export { OrganizationClientSettings };
